/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, AuctionFormat } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateAuctionFormat(options?: Omit<(UseMutationOptions<(AuctionFormat | undefined), DefaultError, Prisma.AuctionFormatCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatCreateArgs, DefaultError, AuctionFormat, true>('AuctionFormat', 'POST', `${endpoint}/auctionFormat/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyAuctionFormat(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.AuctionFormatCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('AuctionFormat', 'POST', `${endpoint}/auctionFormat/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyAuctionFormat<TArgs extends Prisma.AuctionFormatFindManyArgs, TQueryFnData = Array<Prisma.AuctionFormatGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findMany`, args, options, fetch);
}

export function useInfiniteFindManyAuctionFormat<TArgs extends Prisma.AuctionFormatFindManyArgs, TQueryFnData = Array<Prisma.AuctionFormatGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findMany`, args, options, fetch);
}

export function useSuspenseFindManyAuctionFormat<TArgs extends Prisma.AuctionFormatFindManyArgs, TQueryFnData = Array<Prisma.AuctionFormatGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyAuctionFormat<TArgs extends Prisma.AuctionFormatFindManyArgs, TQueryFnData = Array<Prisma.AuctionFormatGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findMany`, args, options, fetch);
}

export function useFindUniqueAuctionFormat<TArgs extends Prisma.AuctionFormatFindUniqueArgs, TQueryFnData = Prisma.AuctionFormatGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueAuctionFormat<TArgs extends Prisma.AuctionFormatFindUniqueArgs, TQueryFnData = Prisma.AuctionFormatGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findUnique`, args, options, fetch);
}

export function useFindFirstAuctionFormat<TArgs extends Prisma.AuctionFormatFindFirstArgs, TQueryFnData = Prisma.AuctionFormatGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstAuctionFormat<TArgs extends Prisma.AuctionFormatFindFirstArgs, TQueryFnData = Prisma.AuctionFormatGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/findFirst`, args, options, fetch);
}

export function useUpdateAuctionFormat(options?: Omit<(UseMutationOptions<(AuctionFormat | undefined), DefaultError, Prisma.AuctionFormatUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatUpdateArgs, DefaultError, AuctionFormat, true>('AuctionFormat', 'PUT', `${endpoint}/auctionFormat/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyAuctionFormat(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.AuctionFormatUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('AuctionFormat', 'PUT', `${endpoint}/auctionFormat/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertAuctionFormat(options?: Omit<(UseMutationOptions<(AuctionFormat | undefined), DefaultError, Prisma.AuctionFormatUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatUpsertArgs, DefaultError, AuctionFormat, true>('AuctionFormat', 'POST', `${endpoint}/auctionFormat/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteAuctionFormat(options?: Omit<(UseMutationOptions<(AuctionFormat | undefined), DefaultError, Prisma.AuctionFormatDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatDeleteArgs, DefaultError, AuctionFormat, true>('AuctionFormat', 'DELETE', `${endpoint}/auctionFormat/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, AuctionFormat, Prisma.AuctionFormatGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyAuctionFormat(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.AuctionFormatDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.AuctionFormatDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('AuctionFormat', 'DELETE', `${endpoint}/auctionFormat/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.AuctionFormatDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.AuctionFormatDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.AuctionFormatDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateAuctionFormat<TArgs extends Prisma.AuctionFormatAggregateArgs, TQueryFnData = Prisma.GetAuctionFormatAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateAuctionFormat<TArgs extends Prisma.AuctionFormatAggregateArgs, TQueryFnData = Prisma.GetAuctionFormatAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/aggregate`, args, options, fetch);
}

export function useGroupByAuctionFormat<TArgs extends Prisma.AuctionFormatGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.AuctionFormatGroupByArgs['orderBy'] } : { orderBy?: Prisma.AuctionFormatGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.AuctionFormatGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.AuctionFormatGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.AuctionFormatGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.AuctionFormatGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.AuctionFormatGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByAuctionFormat<TArgs extends Prisma.AuctionFormatGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.AuctionFormatGroupByArgs['orderBy'] } : { orderBy?: Prisma.AuctionFormatGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.AuctionFormatGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.AuctionFormatGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.AuctionFormatGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.AuctionFormatGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.AuctionFormatGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/groupBy`, args, options, fetch);
}

export function useCountAuctionFormat<TArgs extends Prisma.AuctionFormatCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.AuctionFormatCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/count`, args, options, fetch);
}

export function useSuspenseCountAuctionFormat<TArgs extends Prisma.AuctionFormatCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.AuctionFormatCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.AuctionFormatCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('AuctionFormat', `${endpoint}/auctionFormat/count`, args, options, fetch);
}

export function useCheckAuctionFormat<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; listingId?: string; winningBidId?: string }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('AuctionFormat', `${endpoint}/auctionFormat/check`, args, options, fetch);
}
